import React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect, Route, Switch } from 'react-router-dom';

import PageTitle from '../../../components/pageTitle';
import Navigation from '../../../components/navigation';
import DocumentPreview from '../../../components/modules/documentPreview';
import Search from '../../../components/searchField';
import Pagination from '../../../components/pagination';
import DocumentFilter from '../../../components/modules/documentFilter';
import DocumentService from '../../../services/document.service';

const Folder = ({ folder, t, count }) => !folder ? '' : (
  <div className="current-folder-block">
    <Link className="" to={DocumentService.getFolderUrl(folder.parent_id)}>
      <img src="/img/folder-back.png" />
      {t('Back to the parent folder')}
    </Link>
    <span> - {t('You are in ')} <span className="current-folder-name">{folder.name}</span> {t('folder')} - {count} {t('items in it')}.</span>
  </div>
);


const Documents = ({
  t,
  goToPage,
  criteria,
  chooseDoc,
  groupedDocs,
  resetFilter,
  changeFilter,
  getDatesNames,
  documentsCount,
  folder,
  backgroundColor,
  enableCoverColor,
  backgroundCover,
  callbackToSetSearch,
  moduleTitle,
}) => (
  <React.Fragment>
    <PageTitle
      title={moduleTitle}
      backgroundPage={backgroundColor}
      backgroundCover={backgroundCover}
      enableCoverColor={enableCoverColor}
    />
    <section className="Blog2 boxs dpreview">
      <div className="container">
        <div className="Blog2inner boxs pdlr">
          <Navigation cssClass="leftKB" />
          <div className="middleKB">
            <div className="middleinner boxs">
              <div>
                <div className="docs-search-box"><Search callbackToSetSearch={callbackToSetSearch} placeholder={t('Search documents')} /></div>
                <div className="docs-upload-button"><Link to="/my-docs"><span>{t('Upload documents')}</span><img height="25" alt="" src="/img/upload.svg" /> </Link></div>
                <div className="clear"></div>
              </div>
              <Folder folder={folder} t={t} count={documentsCount} />
              <div className="after3" />
              {
                !!Object.keys(groupedDocs).length &&
                (<React.Fragment>
                  <div className="kbleftw">
                    <div className="previewlinks boxs">
                      {
                        Object.keys(groupedDocs).map(key =>
                          (groupedDocs[key].length &&
                          (<div className="plinks_inner boxs" key={key}>
                            <h3>{getDatesNames[key]}</h3>
                            <ul className="surveytabs boxs portaltabs">
                              {
                                groupedDocs[key].map(doc =>
                                  (<li key={doc.id}>
                                    <a
                                      href="#"
                                      className="docmenttablink"
                                      onClick={e => chooseDoc(e, doc)}
                                    >
                                      {doc.is_folder ? (
                                        <React.Fragment>
                                          <div className="boxs">
                                            <img src="/img/folder.png" alt="arrow" className="folder-icon" />
                                            <span className="three-dots doc-file">{doc.name}</span>
                                            <br/>
                                            <span className="tym">{doc.created_at}</span>
                                            <img src="/img/arrowright.svg" alt="arrow" className="rightarr imgshow" />
                                            <img src="/img/arrowrighthover.svg" alt="arrow" className="rightarr imghide" />
                                          </div>
                                        </React.Fragment>
                                      ) : (
                                        <React.Fragment>
                                          <p className="three-dots doc-file">{doc.original}</p>
                                          <div className="boxs">
                                            <span className={`${doc.type}-tag doctags`}>{doc.type}</span>
                                            <span className="tym">{doc.created_at}</span>
                                            <img src="/img/arrowright.svg" alt="arrow" className="rightarr imgshow" />
                                            <img src="/img/arrowrighthover.svg" alt="arrow" className="rightarr imghide" />
                                          </div>
                                        </React.Fragment>
                                      )}
                                    </a>
                                  </li>))
                                  }
                            </ul>
                          </div>)))
                      }
                      <Pagination
                        goToPage={goToPage}
                        count={documentsCount}
                        pageSize={criteria.limit}
                        page={criteria.page}
                        backgroundColor={backgroundColor}
                      />
                    </div>
                  </div>
                </React.Fragment>)
              }
              { !!Object.keys(groupedDocs).length && (
                <React.Fragment>
                  <div className="kbrightw">
                    <div className="myContent3" />
                    <DocumentFilter
                      color={backgroundColor}
                      callbackToChangeFilter={changeFilter}
                      callbackToResetFilter={resetFilter}
                    />
                    <Switch>
                      <Route
                        exact
                        path="/docs/folder/:folder_id/file/:id"
                        render={prop =>
                          (<DocumentPreview {...prop} />)}
                      />
                      <Route
                        exact
                        path="/docs/file/:id"
                        render={prop =>
                          (<DocumentPreview {...prop} />)}
                      />
                      <Route
                        path="/docs"
                        render={() => (
                          <div className="choosefile boxs chosefl chosefl0">
                            <h2 className="fontmulisemi">{t('Choose a file to preview')}</h2>
                          </div>
                        )}
                      />
                      <Redirect from="*" to="/docs" />
                    </Switch>
                  </div>
                </React.Fragment>
              )}
              { !Object.keys(groupedDocs).length && (
                <div className="kbrightw" style={{ width: '100%' }}>
                  <DocumentFilter
                    color={backgroundColor}
                    callbackToChangeFilter={changeFilter}
                    callbackToResetFilter={resetFilter}
                  />
                  <div className="nopreview boxs chosefl chosefl1">
                    <h2 className="fontmulisemi">{t('No documents available')}</h2>
                    <div className="nopre_img boxs">
                      <img src="/img/nopreview.svg" alt="nopreview" />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  </React.Fragment>
);

Documents.propTypes = {
  t: PropTypes.func.isRequired,
  activeDocument: PropTypes.object,
  goToPage: PropTypes.func.isRequired,
  chooseDoc: PropTypes.func.isRequired,
  criteria: PropTypes.object.isRequired,
  resetFilter: PropTypes.func.isRequired,
  changeFilter: PropTypes.func.isRequired,
  groupedDocs: PropTypes.object.isRequired,
  getDatesNames: PropTypes.object.isRequired,
  documentsCount: PropTypes.number.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  backgroundCover: PropTypes.number,
  callbackToSetSearch: PropTypes.func.isRequired,
};

export default Documents;



// WEBPACK FOOTER //
// ./src/views/modules/documents/Documents.jsx